export default __webpack_public_path__ + "static/media/map-pin-resy.bfa88b2c.svg";